import React from 'react';
import { motion } from 'framer-motion';
import './LandingHero.css';
import LandingButton from '../LandingButton/LandingButton';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

const handleWhatsAppContact = () => {
  const phoneNumber = '573163756770';
  const message = encodeURIComponent('¡Hola! Me gustaría solicitar mi catálogo de OviCatalogos');
  window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
};

function LandingHero() {
  return (
    <section className="ovicatalogos-hero">
      <div className="ovicatalogos-hero-gradient-1" />
      <div className="ovicatalogos-hero-gradient-2" />
      <div className="ovicatalogos-hero-gradient-3" />
      
      <div className="ovicatalogos-hero-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="ovicatalogos-hero-content"
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.1, duration: 0.5 }}
            className="ovicatalogos-hero-logo"
          >
            {/* Logo SVG personalizado de OviCatalogos */}
            <svg className="ovicatalogos-hero-logo-svg" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <linearGradient id="ovi-gradient-1" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#4169E1" />
                  <stop offset="50%" stopColor="#8B5CF6" />
                  <stop offset="100%" stopColor="#10B981" />
                </linearGradient>
                <linearGradient id="ovi-gradient-2" x1="100%" y1="0%" x2="0%" y2="100%">
                  <stop offset="0%" stopColor="#06B6D4" />
                  <stop offset="100%" stopColor="#8B5CF6" />
                </linearGradient>
                <filter id="ovi-glow">
                  <feGaussianBlur stdDeviation="4" result="coloredBlur"/>
                  <feMerge>
                    <feMergeNode in="coloredBlur"/>
                    <feMergeNode in="SourceGraphic"/>
                  </feMerge>
                </filter>
              </defs>
              
              {/* Círculo exterior - Anillo principal */}
              <circle cx="100" cy="100" r="85" fill="none" stroke="url(#ovi-gradient-1)" strokeWidth="8" opacity="0.3" />
              
              {/* Círculo medio */}
              <circle cx="100" cy="100" r="70" fill="none" stroke="url(#ovi-gradient-2)" strokeWidth="6" opacity="0.5" />
              
              {/* Forma central - Representa un catálogo/libro abierto con estilo moderno */}
              <g filter="url(#ovi-glow)">
                {/* Libro/Catálogo base */}
                <path d="M 60 80 L 60 120 Q 60 130 70 130 L 95 130 L 95 70 L 70 70 Q 60 70 60 80 Z" 
                      fill="url(#ovi-gradient-1)" />
                <path d="M 105 70 L 105 130 L 130 130 Q 140 130 140 120 L 140 80 Q 140 70 130 70 Z" 
                      fill="url(#ovi-gradient-2)" />
                
                {/* Líneas de contenido del catálogo */}
                <line x1="68" y1="85" x2="87" y2="85" stroke="white" strokeWidth="2" opacity="0.8" strokeLinecap="round" />
                <line x1="68" y1="95" x2="87" y2="95" stroke="white" strokeWidth="2" opacity="0.8" strokeLinecap="round" />
                <line x1="68" y1="105" x2="87" y2="105" stroke="white" strokeWidth="2" opacity="0.8" strokeLinecap="round" />
                <line x1="68" y1="115" x2="82" y2="115" stroke="white" strokeWidth="2" opacity="0.8" strokeLinecap="round" />
                
                <line x1="113" y1="85" x2="132" y2="85" stroke="white" strokeWidth="2" opacity="0.8" strokeLinecap="round" />
                <line x1="113" y1="95" x2="132" y2="95" stroke="white" strokeWidth="2" opacity="0.8" strokeLinecap="round" />
                <line x1="113" y1="105" x2="132" y2="105" stroke="white" strokeWidth="2" opacity="0.8" strokeLinecap="round" />
                <line x1="118" y1="115" x2="132" y2="115" stroke="white" strokeWidth="2" opacity="0.8" strokeLinecap="round" />
                
                {/* Separador central del libro */}
                <line x1="100" y1="70" x2="100" y2="130" stroke="#ffffff" strokeWidth="2" opacity="0.3" />
              </g>
              
              {/* Elementos decorativos - Estrellas/Destellos */}
              <circle cx="45" cy="50" r="3" fill="#10B981" opacity="0.6">
                <animate attributeName="opacity" values="0.6;1;0.6" dur="2s" repeatCount="indefinite" />
              </circle>
              <circle cx="155" cy="60" r="2.5" fill="#8B5CF6" opacity="0.7">
                <animate attributeName="opacity" values="0.7;1;0.7" dur="2.5s" repeatCount="indefinite" />
              </circle>
              <circle cx="150" cy="145" r="3" fill="#06B6D4" opacity="0.6">
                <animate attributeName="opacity" values="0.6;1;0.6" dur="3s" repeatCount="indefinite" />
              </circle>
              <circle cx="50" cy="150" r="2" fill="#F59E0B" opacity="0.7">
                <animate attributeName="opacity" values="0.7;1;0.7" dur="2.2s" repeatCount="indefinite" />
              </circle>
              
              {/* Texto "O" estilizado en el centro del libro */}
              <text x="100" y="108" fontSize="28" fontWeight="bold" fill="white" textAnchor="middle" opacity="0.9">O</text>
            </svg>
            
            <h1 className="ovicatalogos-hero-title">OviCatalogos</h1>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.2, duration: 0.5 }}
            className="ovicatalogos-hero-badge"
          >
            <div className="ovicatalogos-hero-badge-pulse" />
            <span className="ovicatalogos-hero-badge-text">La solución definitiva para tu negocio</span>
          </motion.div>
          
          <h2 className="ovicatalogos-hero-headline">
            Catálogos Inteligentes{' '}
            <span className="ovicatalogos-hero-headline-gradient">
              que trabajan por ti
            </span>
          </h2>
          
          <p className="ovicatalogos-hero-description">
            ¿Cansado de perder ventas por catálogos desactualizados? Con OviCatalogos, cuando se te agota un producto, 
            simplemente lo inhabilitas y desaparece automáticamente. Tus clientes reciben pedidos directamente en WhatsApp. 
            Simple, rápido y sin complicaciones.
          </p>
          
          <div className="ovicatalogos-hero-buttons">
            <LandingButton
              variant="primary"
              size="lg"
              icon={faWhatsapp}
              onClick={handleWhatsAppContact}
            >
              Solicitar mi catálogo
            </LandingButton>
            
            <LandingButton
              variant="outline"
              size="lg"
            >
              Ver demo
            </LandingButton>
          </div>
          
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.8 }}
            className="ovicatalogos-hero-features"
          >
            Perfecto para cualquier negocio • Sincronización automática • Pedidos por WhatsApp
          </motion.p>
        </motion.div>
      </div>
    </section>
  );
}

export default LandingHero;
